import { Paths } from 'shared/routes/paths';

import { Goals } from './goals';
import { Summary } from './summary';
import { Tasks } from './tasks';
import { Vision } from './vision';

export const LifeAreaDetailRoutes = [
  {
    path: Paths.LifeAreaDetail,
    element: <Summary />,
  },
  {
    path: Paths.LifeAreaDetailVision,
    element: <Vision />,
  },
  {
    path: Paths.LifeAreaDetailGoals,
    element: <Goals />,
  },
  {
    path: Paths.LifeAreaDetailTasks,
    element: <Tasks fullSize />,
  },
];
